import { Injectable } from '@angular/core';
import { WorkQueueService } from '@core/services//work-queue//work-queue.service';
import { WorkQueueDetails } from '@core/services/work-queue/work-queue.model';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as lenderRemediationQueueActions from '../lender-remediation/lender-remediation.actions';

@Injectable()
export class LenderRemediationQueueEffect {
  constructor(private actions$: Actions, private workQueueService: WorkQueueService) { }

  
  loadlenderremediationqueues$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType<lenderRemediationQueueActions.LOADLENDERREMEDIATIONQUEUE>(
      lenderRemediationQueueActions.lenderRemediationQueueActionTypes.LOAD_LENDERREMEDIATIONQUEUE
    ),
    mergeMap((action: lenderRemediationQueueActions.LOADLENDERREMEDIATIONQUEUE) =>
      this.workQueueService.GetWorkQueue(action.queuetype, action.workqueueStatusId, action.accountUpdateOptionId, action.customerFollowUpOptionId, action.investigationOptionId, action.insuranceFollowUpOptionId).pipe(
        map(
          (confirmedmovedetails: WorkQueueDetails) =>
            new lenderRemediationQueueActions.LOADLENDERREMEDIATIONQUEUESUCCESS(confirmedmovedetails)
        ),
        catchError(err => of(new lenderRemediationQueueActions.LOADLENDERREMEDIATIONQUEUEFAIL(err)))
      )
    )
  ));
}
